module.exports = __webpack_public_path__ + "img/anti_gaspi.3cdf4523.svg";